import { render, staticRenderFns } from "./VideoBannerExternal.vue?vue&type=template&id=a17ef5a4&scoped=true&"
import script from "./VideoBannerExternal.vue?vue&type=script&lang=ts&"
export * from "./VideoBannerExternal.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBannerExternal.vue?vue&type=style&index=0&id=a17ef5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17ef5a4",
  null
  
)

export default component.exports